import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { BixiColorAlphaComponent } from './color-alpha.component';
import { BixiColorBlockComponent } from './color-block.component';
import { BixiColorFieldsComponent } from './color-fields.component';
import { BixiColorHueComponent } from './color-hue.component';
import { BixiColorPanelComponent } from './color-panel.component';
import { BixiColorPickerComponent } from './color-picker.component';
import { BixiColorSaturationComponent } from './color-saturation.component';
import { BixiCoordinatesDirective } from './coordinates.directive';

const DIRECTIVES = [
  BixiCoordinatesDirective
];

const COMPONENTS = [
  BixiColorAlphaComponent,
  BixiColorBlockComponent,
  BixiColorFieldsComponent,
  BixiColorHueComponent,
  BixiColorPanelComponent,
  BixiColorPickerComponent,
  BixiColorSaturationComponent
];

@NgModule({
  imports: [CommonModule, FormsModule, NzPopoverModule, NzInputModule],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...DIRECTIVES]
})
export class BixiColorPickerModule {
}
